import React, { useEffect } from "react";
import differenceInYears from "date-fns/differenceInYears";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import classnames from "classnames";

import Header from "../Header/header";
import Footer from "../Footer/footer";
import ROUTES from "../../../../constants/routes";

import "./styles.css";
import { useActions } from "../../../../hooks/useActions";
import { loadChannel } from "../../../../redux/home-insurance/home-insurance.actions";
import Datalayer from "../../../../libs/vendors/data-layer";
import { getPagePath, getPageName } from "../../../../libs/helpers/location";
import {
    AFFILIATION,
    ECOMMERCE_NAME,
    NOT_AVAILABLE,
    PARTNER_TYPE,
} from "../../../../constants/datalayer";
import ActivePromotionBanner from "../ActivePromotionBanner/ActivePromotionBanner";
import {
    CLIENT_TYPE_LABELS,
    WHICHENSURE_TYPE_LABELS,
} from "../../../../constants/personaldata";
import { HOUSING_TYPE_LABELS } from "../../../../constants/housing";
import { PAYMENT_TYPES, PAYMENT_TYPES_LABELS } from "../../../../constants/payment";

const MainContainer = ({ children, partner, partnerType }) => {
    const {
        mainContainer: { topCmp: TopCmp },
        partnerIsLoad,
    } = useSelector(state => state.Page);
    const {
        quotation: {
            requestId,
            initialQuotationForm: { data: clientData },
            guessPriceForm: {
                data: { housingValue, assetValue },
            },
            housingInfoForm: { data: houseInfo },
            paymentForm: {
                totalPrice,
                data: { paymentType, cardType },
            },
            paymentResult,
        },
        ubigeoMap,
    } = useSelector(state => ({
        ...state.HomeInsurance,
    }));
    const location = useLocation();
    const actions = useActions(
        {
            loadChannel,
        },
        []
    );

    const senDatalayerInfoCheckout = () => {
        const district = ubigeoMap
            ? ubigeoMap[houseInfo.location].location.split("|")[0].trim()
            : "";
        const years = differenceInYears(new Date(), new Date(clientData.birthDate));
        const data = {
            currencyCode: "PEN",
            checkout: {
                actionField: { step: 1 },
                products: [
                    {
                        id: requestId,
                        name: ECOMMERCE_NAME,
                        price: `${totalPrice}`,
                        brand: PARTNER_TYPE.default,
                        category: ECOMMERCE_NAME,
                        variant: CLIENT_TYPE_LABELS[clientData.clientType],
                        quantity: 1,
                        dimension4: `${housingValue}`,
                        dimension5: district,
                        dimension6: WHICHENSURE_TYPE_LABELS[clientData.whichEnsure],
                        dimension7: HOUSING_TYPE_LABELS[clientData.housingType],
                        dimension8: `${houseInfo.housingAge} años`,
                        dimension10: `${years}`,
                        dimension11: `${houseInfo.squareMeters} m2`,
                        coupon: NOT_AVAILABLE,
                        dimension14: NOT_AVAILABLE,
                        dimension3: `${assetValue}`,
                    },
                ],
            },
        };
        Datalayer.productCheckout(requestId, data);
    };

    const senDatalayerInfoPurchase = () => {
        const district = ubigeoMap
            ? ubigeoMap[houseInfo.location].location.split("|")[0].trim()
            : "";
        const years = differenceInYears(new Date(), new Date(clientData.birthDate));
        const paymentTypeLabel = `${PAYMENT_TYPES_LABELS[paymentType]}${paymentType === PAYMENT_TYPES.CREDIT_CARD ? `: ${cardType}` : ""
            }`;
        const data = {
            currencyCode: "PEN",
            purchase: {
                actionField: {
                    affiliation: AFFILIATION,
                    revenue: `${totalPrice}`,
                    id: paymentResult.policyNumber,
                    tax: `${totalPrice * 0.18}`,
                    coupon: NOT_AVAILABLE,
                    shipping: NOT_AVAILABLE,
                },
                products: [
                    {
                        id: requestId,
                        name: ECOMMERCE_NAME,
                        price: `${totalPrice}`,
                        brand: PARTNER_TYPE.default,
                        category: ECOMMERCE_NAME,
                        variant: CLIENT_TYPE_LABELS[clientData.clientType],
                        quantity: 1,
                        dimension4: `${housingValue}`,
                        dimension5: district,
                        dimension6: WHICHENSURE_TYPE_LABELS[clientData.whichEnsure],
                        dimension7: HOUSING_TYPE_LABELS[clientData.housingType],
                        dimension8: `${houseInfo.housingAge} años`,
                        dimension10: `${years}`,
                        dimension11: `${houseInfo.squareMeters} m2`,
                        coupon: NOT_AVAILABLE,
                        dimension14: NOT_AVAILABLE,
                        dimension3: `${assetValue}`,
                    },
                ],
            },
        };
        Datalayer.orderPurchase(requestId, paymentTypeLabel, "Anual", data);
    };

    useEffect(() => {
        if (partnerIsLoad) {
            Datalayer.setPartner(partner, partnerType);
        }
    }, [partnerIsLoad]);

    useEffect(() => {
        actions.loadChannel({
            partner,
            partnerType,
            url: getPagePath(location.pathname, partner, partnerType),
            name: getPageName(location.pathname, partner, partnerType),
            isDefault: partnerType === PARTNER_TYPE.default,
        });
    }, []);

    useEffect(() => {
        if (partnerIsLoad) {
            Datalayer.pageView(
                getPagePath(location.pathname, partner, partnerType),
                getPageName(location.pathname, partner, partnerType),
                partner,
                partnerType,
                clientData.documentNumber
            );
        }
        if (location.pathname.includes(ROUTES.HOME_INSURANCE.STEP5)) {
            senDatalayerInfoCheckout();
        }
        if (location.pathname.includes(ROUTES.HOME_INSURANCE.CONFIRM1)) {
            senDatalayerInfoPurchase();
        }
    }, [location.pathname, partnerIsLoad]);

    return (
        <div
            className={classnames("main-container", {
                "main-container--custom-plan": location.pathname.includes(
                    ROUTES.HOME_INSURANCE.STEP3
                ),
            })}
        >
            <div className="main-container__top">
                <Header />
                <ActivePromotionBanner />

                {TopCmp && <TopCmp />}
            </div>
            <div className="main-container__content">
                <div className="main-container__main">{children}</div>
                <div className="main-container__bottom">
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default MainContainer;
